import React from 'react';
import { FormattedMessage } from 'react-intl';

const SiteCell = (props) => {
  const getSite = props?.cell?.row?.original?.sites;
  return (
    <>
      <p>
        {getSite ? (
          getSite[0]?.name
        ) : (
          <FormattedMessage id="client.contract.invoiceItems.allSites" />
        )}
      </p>
    </>
  );
};

export default SiteCell;
